import React from 'react';
import { useSelector } from 'react-redux';
import { getCoverageState } from '../store/selectors/getCoverage';
import MoreCoverage from '../MoreCoverage';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import moreCoverageReducer from '../store/reducers/morecoverage';

import cmsdapiDatasource from '@gameday/core/datasources/cmsDapi';
import contentGraphDataSource from '@gameday/core/datasources/contentGraph';
import moreCoverageDataRequestAction from '../store/actions/moreCoverageDataRequestAction';

initContainerData.register({
    datasources: {
        cmsdapi: cmsdapiDatasource,
        contentGraph: contentGraphDataSource
    },
    reducers: {
        morecoverage: moreCoverageReducer
    }
});

const fetchData = () => {
    return moreCoverageDataRequestAction();
};

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const MoreCoverageDataContainer = (props) => {
    const moreCoverageState = useSelector(getCoverageState);

    return (
        <MoreCoverage { ...moreCoverageState } {...props} />
    );
};

export default MoreCoverageDataContainer;
export { fetchData, routes };
